var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoMarkColor(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1454px",
    height: "1512px",
    viewBox: "0 0 1454 1512",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "orbiter") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "gravity-mark-inverse",
    transform: "translate(-471.000000, -418.000000)",
    fill: "#576CB5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "orbiter",
    transform: "translate(471.449875, 418.358396)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M940.832576,140.91384 C934.812461,158.569038 930.612567,177.002632 928.443139,196.014897 C872.82995,180.367822 814.158184,171.996509 753.526198,171.996509 C423.524994,171.996509 151.591182,419.979009 114.809343,739.310705 C106.575261,737.735905 98.0738352,736.911454 89.3793562,736.911454 C78.502666,736.911454 67.9280979,738.201696 57.8010974,740.637106 C94.23863,389.463546 391.820614,115.617414 753.526198,115.617414 C818.403607,115.617414 881.218039,124.427562 940.832581,140.913841 Z M1360.7036,466.680823 C1419.42605,568.799156 1453,687.143114 1453,813.308707 C1453,925.707294 1426.35337,1031.89809 1379.01746,1125.93891 C1365.16148,1112.89466 1349.34724,1101.89779 1332.06098,1093.43331 C1373.32777,1008.79714 1396.47686,913.749412 1396.47686,813.308707 C1396.47686,694.876158 1364.29164,583.941714 1308.16962,488.732798 C1326.55676,483.011519 1344.13624,475.596118 1360.7036,466.680829 Z M80.6219792,1004.43179 C83.5170786,1004.61774 86.4371639,1004.71215 89.3793562,1004.71215 C106.166598,1004.71215 122.234146,1001.63863 137.047253,996.024967 C215.923161,1261.19671 462.078649,1454.62091 753.526198,1454.62091 C874.759352,1454.62091 988.155611,1421.15267 1084.93489,1362.97391 C1094.90023,1379.34065 1107.27091,1394.08894 1121.5576,1406.73068 C1014.65062,1472.83547 888.556696,1511 753.526198,1511 C433.65861,1511 163.938367,1296.84084 80.6219829,1004.43181 Z",
    id: "Combined-Shape"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 1204.85391,
    cy: 232.23153,
    rx: 232.20096,
    ry: 232.23153
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 756.397119,
    cy: 814.305409,
    rx: 375.707133,
    ry: 375.756596
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 1237.74074,
    cy: 1251.85752,
    rx: 143.506173,
    ry: 143.525066
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 88.6947874,
    cy: 870.120712,
    rx: 88.6947874,
    ry: 88.7064644
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoMarkColor);
export default __webpack_public_path__ + "static/media/logo-mark-color.4b52b243d9ec1e9e354a1815129af59d.svg";
export { ForwardRef as ReactComponent };